import { render, staticRenderFns } from "./publishEventStatis.vue?vue&type=template&id=c066999c&scoped=true&"
import script from "./publishEventStatis.vue?vue&type=script&lang=js&"
export * from "./publishEventStatis.vue?vue&type=script&lang=js&"
import style0 from "./publishEventStatis.vue?vue&type=style&index=0&id=c066999c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c066999c",
  null
  
)

export default component.exports